import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
  AlertBoxOptions,
  AlertClosingType,
  AlertType,
  PrimaryButton
} from "@core/models/alert-box-types";

@Component({
    selector: "bci-alert",
    templateUrl: "./alert-dialog.component.html",
    styleUrls: ["./alert-dialog.component.scss"],
    standalone: false
})
export class AlertDialogComponent implements OnInit, AfterViewInit {
  @ViewChild("outerLeftBtnRaised", { read: ElementRef })
  outerLeftBtnRaised: ElementRef;
  @ViewChild("leftBtnRaised", { read: ElementRef })
  leftBtnRaised: ElementRef;
  @ViewChild("rightBtnRaised", { read: ElementRef })
  rightBtnRaised: ElementRef;

  AlertType = AlertType;
  AlertClosingType = AlertClosingType;
  PrimaryButton = PrimaryButton;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AlertBoxOptions,
    public dialogRef: MatDialogRef<AlertDialogComponent>
  ) {}

  ngOnInit(): void {}

  close(type: AlertClosingType): void {
    this.dialogRef.close(type);
  }

  ngAfterViewInit(): void {
    switch (this.data.primaryButton) {
      case PrimaryButton.LeftButton:
        this.leftBtnRaised.nativeElement.focus();
        break;
      case PrimaryButton.RightButton:
        this.rightBtnRaised.nativeElement.focus();
        break;
      case PrimaryButton.OuterLeftButton:
        this.outerLeftBtnRaised.nativeElement.focus();
        break;
    }
  }
}
